/**
 * Картинка → JPEG не больше maxSide по длинной стороне.
 *
 * Скриншот с телефона весит несколько мегабайт, а в теле запроса к нашей
 * функции он едет строкой base64 — и в исходном виде упирается в лимит
 * Vercel (4,5 МБ). Для чтения цифр хватает ширины экрана телефона.
 */
export async function downscaleToDataUrl(source: Blob, maxSide = 1100, quality = 0.85): Promise<string> {
  const url = URL.createObjectURL(source);
  try {
    const image = new Image();
    image.decoding = 'async';
    image.src = url;
    await image.decode();
    const scale = Math.min(1, maxSide / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas недоступен');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', quality);
  } finally {
    URL.revokeObjectURL(url);
  }
}
